const PLACEHOLDER = '{{user_name}}';

function firstName(fullName) {
  const trimmed = (fullName || '').trim();
  if (!trimmed) return 'Utilizador';
  return trimmed.split(/\s+/)[0];
}

function replaceInValue(value, name) {
  if (typeof value === 'string') {
    return value.split(PLACEHOLDER).join(name);
  }
  if (Array.isArray(value)) {
    return value.map((item) => replaceInValue(item, name));
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, replaceInValue(item, name)]),
    );
  }
  return value;
}

/**
 * Substitui {{user_name}} no payload do relatório antes de renderizar.
 */
export function fillReportPlaceholders(report, profile) {
  if (!report) return report;
  const name = firstName(profile?.full_name);
  return replaceInValue(report, name);
}

export function isReportPending(status) {
  return status === 'pending' || status === 'regenerating';
}

export function isReportReady(status) {
  return status === 'ready' || status === 'failed';
}

export function reportSeenKey(snapshotId) {
  return `evplanner_report_seen_${snapshotId}`;
}

export function markReportSeen(snapshotId) {
  if (!snapshotId) return;
  try {
    localStorage.setItem(reportSeenKey(snapshotId), '1');
  } catch {
    /* ignore */
  }
}

export function hasSeenReport(snapshotId) {
  if (!snapshotId) return true;
  try {
    return localStorage.getItem(reportSeenKey(snapshotId)) === '1';
  } catch {
    return true;
  }
}
